import ownerListComponent from './owner-list.component';

const ownerListModule = angular.module('ownerList', [
])
  .component('ownerList', ownerListComponent)
  .name;

export default ownerListModule;
